import { IMAGES } from '@shared/constants';
import { ImageFallback } from '@shared/ui';
export const SplashSection = () => <div id="splash-section" role="status" aria-live="polite" aria-label="Loading" data-sentry-component="SplashSection" data-sentry-source-file="index.tsx">
    <div className="splash-section-card" aria-hidden="true">
      <div className="splash-section-track">
        <ImageFallback className="splash-section-sloth" src={IMAGES.SLOTH_SURFING} alt="loading" width={200} height={200} data-sentry-element="ImageFallback" data-sentry-source-file="index.tsx" />
        <div className="splash-section-bar">
          <div className="splash-section-bar-fill"></div>
        </div>
      </div>
    </div>
  </div>;